 export enum AideEnLigneFonction {
GENERAL_ACCUEIL = 0,
SALARIE_LISTE = 1,
SALARIE_NOUVEAU = 2,
SALARIE_DEMANDE_ENTREE = 3,
SALARIE_DEMANDE_SORTIE = 4,
SALARIE_ENTREE = 5,
SALARIE_SORTIE = 6,
SALARIE_NOTAIRES = 7,
TRAITEMENT_GESTION_ABSENCES = 8,
TRAITEMENT_PLANNING_ABSENCES = 9,
TRAITEMENT_ELEMENTS_VARIABLES = 10,
TRAITEMENT_HISTORIQUE_VARIABLES = 11,
TRAITEMENT_CALCUL_PAIE = 12,
TRAITEMENT_DSN = 13,
TRAITEMENT_DSN_CONTRAT_AUTO = 14,
EDITION_TABLEAUX = 15,
EDITION_DOCUMENTS = 16,
PARAMETRAGE_PARAMETRES_RUBRIQUES = 17,
PARAMETRAGE_SCENARIOS = 18,
PARAMETRAGE_PARAMETRES_LIBELLES = 19,
PARAMETRAGE_PARAMETRES_SOCIETE = 20,
PARAMETRAGE_JOURS_NON_TRAVAILLES = 21,
PARAMETRAGE_CONTRAT_TYPE = 22,
PARAMETRAGE_EXERCICE = 23,
PARAMETRAGE_PARAMETRES_SPECIFIQUES = 24,
PARAMETRAGE_PARAMETRES_MODULE = 25,
PARAMETRAGE_LISTE_SOCIETES = 26,
ADMINISTRATION_UTILISATEURS = 27,
ADMINISTRATION_STATUS = 28,
ADMINISTRATION_HISTORIQUE_VARIABLES = 29,
REQUETEUR = 30,
REQUETEUR_MODIFIEUR = 31,
REQUETEUR_TABLE = 32,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/AideEnLigneFonction.ts